<template>
    <div>
        <div v-if="feedbackSaved">
            <h4><i class="fa fa-smile-o mr-2" aria-hidden="true"></i>{{ $lang('Ocena obsługi') }}</h4>
            <hr class="colorgraph">
            <span v-html="rateInfo"></span>
            <span class="ml-1" v-if="canEdit">
                (<a class="font-weight-bold" href="#" @click="openFeedbackModal">{{ $lang('Edytuj') }}</a>)
            </span>
            <p v-if="comment">
                <b>{{ $lang('Dodano komentarz do oceny:') }}</b>
                <span>{{ comment }}</span>
            </p>
        </div>
        <div v-else-if="canFeedback">
            <h4><i class="fa fa-smile-o mr-2" aria-hidden="true"></i>{{ $lang('Ocena obsługi') }}</h4>
            <hr class="colorgraph">
            <span class="ml-1">
                <button class="btn btn-default" href="#" @click="openFeedbackModal">{{ $lang('Dodaj ocenę') }}</button>
            </span>
        </div>
        <div class="modal fade" id="taskFeedbackModal" tabindex="-1" role="dialog" data-backdrop="static">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ $lang('Ocena obsługi zgłoszenia') }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="d-flex flex-column">
                            <div>
                                <p>{{ $lang('Jak oceniają Państwo jakość obsługi tego zgłoszenia?') }}</p>
                            </div>
                            <vue-feedback-reaction ref="reaction" v-model="editable.rate" :labels="labels" label-class="small"/>
                            <div class="form-group mt-3" v-if="editable.rate > 0">
                                <template  v-if="editable.rate < 3">
                                    <label for="feedback_note">
                                        {{ $lang('Co możemy poprawić, aby w przyszłości uzyskać lepszą ocenę?') }}
                                    </label>
                                    <span class="ml-1 text-danger small">({{ $lang('wymagane') }})</span>
                                </template>
                                <label for="feedback_note" v-else>
                                    {{ $lang('Komentarz do oceny') }}
                                    <span class="ml-1 small">({{ $lang('opcjonalnie') }})</span>
                                </label>
                                <textarea class="form-control" id="feedback_note" name="feedback_note" v-model="editable.comment"
                                          rows="3"></textarea>
                            </div>
                            <div class="mt-4">
                                <p>{{$lang('Prosimy o wystawienie oceny w ciągu :days dni roboczych. Po tym czasie system automatycznie przydzieli najwyższą ocenę.', {days: daysToFeedback})}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-default" data-dismiss="modal">{{ $lang('Ocenię później') }}</button>
                        <button :disabled="!editable.rate || (editable.rate < 3 && !editable.comment?.length)" class="btn btn-primary" @click="save">{{ $lang('Zapisz') }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {VueFeedbackReaction} from 'vue-feedback-reaction';
import ShowNotification from "../../mixins/show-notification";
import axios from "axios";
import moment from "moment";

export default {
    components: {VueFeedbackReaction},
    mixins: [ShowNotification],
    props: {
        getUrl: {type: String, required: true},
        saveUrl: {type: String, required: true},
    },
    data() {
        return {
            daysToFeedback: 14,
            feedbackSaved: false,
            rate: 0,
            comment: '',
            date: null,
            canEdit: false,
            aut: false,
            canFeedback: false,
            editable: {
                rate: 0,
                comment: ''
            },
            labels: [
                this.$lang('Bardzo źle (1)'),
                this.$lang('Źle (2)'),
                this.$lang('Przeciętnie (3)'),
                this.$lang('Dobrze (4)'),
                this.$lang('Bardzo dobrze (5)'),
            ]
        }
    },
    mounted() {
        this.getFeedback();
    },
    methods: {
        openFeedbackModal() {
            this.assignEditable();
            this.$refs.reaction.reactionValue = this.editable.rate ? this.editable.rate.toString() : '';
            $('#taskFeedbackModal').modal('show');
        },
        getFeedback() {
            let self = this;
            return axios.get(this.getUrl).then((response) => {
                if (response.data.feedback) {
                    self.assignFeedbackData(response.data.feedback);
                    self.canEdit = response.data.can_edit;
                } else if (response.data.can_feedback) {
                    self.canFeedback = true;
                    self.daysToFeedback = response.data.days_to_feedback;
                    self.openFeedbackModal();
                }
            }).catch((error) => {
                const message = (error.response.data ? error.response.data : error.response.statusText);
                this.showNotification('error', message);
            });
        },
        save() {
            const self = this;
            axios.post(this.saveUrl, this.editable)
                 .then(function (response) {
                     self.assignFeedbackData(response.data.feedback);
                     self.canFeedback = false;
                     self.canEdit = response.data.can_edit;
                 })
                 .catch(function (error) {
                     self.showRequestErrorNotification();
                     console.log(error);
                 })
                 .finally(() => {
                     $('#taskFeedbackModal').modal('hide');
                 });
        },
        assignFeedbackData(feedback) {
            this.rate = feedback.rate;
            this.comment = feedback.comment;
            this.date = moment(feedback.updated_at).format("DD.MM.YYYY");
            this.aut = feedback.auto;

            this.assignEditable();

            this.feedbackSaved = true;
            this.canFeedback = false;
        },
        assignEditable() {
            this.editable = {rate: this.rate, comment: this.comment};
        },
    },
    computed: {
        rateInfo() {
            if (this.rate && this.date) {
                return this.$lang('Dnia :date obsługa tego zgłoszenia otrzymała ocenę <b>:rate/5</b>:aut.', {
                    rate: this.rate,
                    date: this.date,
                    aut: this.aut ? ' (aut.)' : ''
                });
            }

            return '';
        }
    }
}
</script>
